import { doc } from './common'
import { getDb } from './db'

export const composeQuery = (...queryFunctions) =>
  queryFunctions.reduce((acc, func) => func(acc), null)

export const getId = ({ '.key': key, id }) => id || key
export const asRecordId = (record) =>
  record['.key'] || record.id ? getId(record) : record

export const isNewRecord = (record) => !getId(record)

export const getRootCollection = (name) => getDb().collection(name)
export const collectionGroup = (name) => getDb().collectionGroup(name)

export const getDocRef = (query) => (id) =>
  composeQuery(query, doc(asRecordId(id)))
